"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _HelpText = _interopRequireDefault(require("./HelpText.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HelpText = function HelpText(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/_react["default"].createElement(_HelpText["default"], null, message);
};
HelpText.propTypes = {
  message: _propTypes["default"].string.isRequired
};
HelpText.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HelpText",
  "props": {
    "message": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = HelpText;
exports["default"] = _default;